export default __webpack_public_path__ + "static/media/1.703c181b.png";